import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { updateModalProductInfo } from './productinfo.js';
import { BREAKPOINTS } from './breakpoints.js';

export function initImageGalleryCarousel() {
    const galleryContainers = document.querySelectorAll('.cmp-imagegallery');

    galleryContainers.forEach((galleryContainer) => {
        const swiperEl = galleryContainer.querySelector('.swiper');
        const nextBtn = galleryContainer.querySelector('.swiper-button-next');
        const prevBtn = galleryContainer.querySelector('.swiper-button-prev');

        const mainSwiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            breakpoints: {
                350: { slidesPerView: 1.2 },
                [BREAKPOINTS.LARGE]: { slidesPerView: 1.5 },
            },
        });

        const modal = document.getElementById('image-modal');
        const modalClose = document.getElementById('image-modal-close');
        const modalSwiperWrapper = document.getElementById('modal-swiper-wrapper');

        const modalNextBtns = modal.querySelectorAll('.swiper-button-next');
        const modalPrevBtns = modal.querySelectorAll('.swiper-button-prev');
        
        const modalSwiper = new Swiper('.modal-swiper', {
          slidesPerView: 1,
          navigation: {
            nextEl: Array.from(modalNextBtns),
            prevEl: Array.from(modalPrevBtns),
          },
          on: {
            slideChange: function () {
              updateModalMetadata(modalSwiper.activeIndex);
            }
          }
        });
        const updateModalMetadata = (index) => {
            const slide = modalSwiperWrapper.children[index];
            const metaScript = slide.querySelector('.cmp-imagegallery__modal-meta');

            if (metaScript) {
                try {
                    const meta = JSON.parse(metaScript.textContent);
                    
                    // Update product info using shared utility
                    updateModalProductInfo(meta, modal);
                } catch (e) {
                    console.error('Error parsing modal metadata:', e);
                }
            }
        };

        // Open modal and go to correct slide
        galleryContainer.querySelectorAll('.cmp-imagegallery__modal-button').forEach((btn, index) => {
            btn.addEventListener('click', () => {
                modal.removeAttribute('hidden');
                modalSwiper.slideToLoop(index);
                updateModalMetadata(index);
            });
        });

        const modalCloseMobile = document.getElementById('image-modal-close--mobile');

        modalClose.addEventListener('click', () => {
            modal.setAttribute('hidden', 'true');
        });
        
        if (modalCloseMobile) {
            modalCloseMobile.addEventListener('click', () => {
                modal.setAttribute('hidden', 'true');
            });
        }
    });
}
